export const childrenCategoryDerivationType = {
  PERCENTAGE: 1,
  FIXED: 2
}
